// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__3__Ja","Open":"SideDrawer__Open__2Pp4a","Close":"SideDrawer__Close__3GAFT","Logo":"SideDrawer__Logo__9Tynh"};